import { useMemo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Reaction } from '../../../../generated/graphql';

type CommunityPostCellProps = {
  reactions: Reaction[];
  onAddComment: () => void;
};

export const PostFooter = ({
  reactions,
  onAddComment,
}: CommunityPostCellProps) => {
  const commentsCount = useMemo(() => {
    const comments = reactions.find(
      (reaction: Reaction) => reaction.type === 'Comment',
    );
    return comments?.count ?? 0;
  }, [reactions]);

  return (
    <Box className="flex flex-row justify-between items-center">
      <Typography
        sx={{
          fontWeight: '800',
          fontSize: '0.6rem',
          lineHeight: '0.875rem',
          textTransform: 'uppercase',
        }}
      >
        {commentsCount === 1 ? '1 comment' : `${commentsCount} comments`}
      </Typography>
      <Button variant="text" onClick={onAddComment}>
        <Typography
          sx={{
            fontWeight: '800',
            fontSize: '0.6rem',
            lineHeight: '0.875rem',
            textTransform: 'uppercase',
            color: '#AD65F5',
          }}
        >
          Add comment
        </Typography>
      </Button>
    </Box>
  );
};
